import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import App from './App'
import { store } from './store'
import 'leaflet/dist/leaflet.css'
import './index.css'

const CHUNK_RECOVERY_FLAG = 'cbms_chunk_recovery_once'

function recoverFromStaleBundle(reason: string) {
  if (sessionStorage.getItem(CHUNK_RECOVERY_FLAG)) return

  sessionStorage.setItem(CHUNK_RECOVERY_FLAG, reason)
  localStorage.removeItem('cbms_token')
  const recoveryUrl = `/entry?recovered=${encodeURIComponent(reason)}`

  if ('caches' in window) {
    caches.keys().then((keys) => Promise.allSettled(keys.map((key) => caches.delete(key)))).finally(() => {
      globalThis.location.replace(recoveryUrl)
    })
    return
  }

  globalThis.location.replace(recoveryUrl)
}

window.addEventListener('error', (event) => {
  const target = event.target as HTMLScriptElement | HTMLLinkElement | null
  const source = target instanceof HTMLScriptElement ? target.src : target instanceof HTMLLinkElement ? target.href : ''
  if (source.includes('/assets/')) {
    recoverFromStaleBundle('asset-load-failed')
  }
}, true)

window.addEventListener('unhandledrejection', (event) => {
  const reasonText = String(event.reason || '')
  if (reasonText.includes('Failed to fetch dynamically imported module') || reasonText.includes('Importing a module script failed')) {
    recoverFromStaleBundle('dynamic-import-failed')
  }
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
)

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    sessionStorage.removeItem(CHUNK_RECOVERY_FLAG)

    // The management console must always serve the latest bundle.
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister().catch(() => {
          // ignore unregister failures during cleanup
        })
      })
    })

    if ('caches' in window) {
      caches.keys().then((keys) => {
        keys.forEach((key) => {
          caches.delete(key).catch(() => {
            // ignore cache cleanup failures during cleanup
          })
        })
      })
    }
  })
}
